// src/components/common/MaintenanceChecker.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import MaintenancePage from './Maintenance';
 
const MaintenanceChecker = ({ children }) => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isChecking, setIsChecking] = useState(true); // Renamed for clarity
  const navigate = useNavigate();
  const location = useLocation();
 
  const checkMaintenance = useCallback(async () => {
    setIsChecking(true);
    try {
      const res = await api.get('/system/status');
      const maintenanceMode = res.data.maintenanceMode || false;
      setIsMaintenance(maintenanceMode);
 
      // OFF -> From maintenance page to home INSTANTLY
      if (!maintenanceMode && location.pathname === '/maintenance') {
        navigate('/', { replace: true });
        return;
      }
 
      // ON -> Non-admin to maintenance INSTANTLY  
      if (maintenanceMode &&
          location.pathname !== '/maintenance' &&
          !location.pathname.startsWith('/admin')) {
        navigate('/maintenance', { replace: true });
        return;
      }
    } catch (err) {
      console.error('Failed to check maintenance mode:', err);
      setIsMaintenance(false);
    } finally {
      setIsChecking(false);
    }
  }, [location.pathname, navigate]);
 
  // Check on mount + route change
  useEffect(() => {
    checkMaintenance();
  }, [checkMaintenance]);
 
  // REAL-TIME POLLING every 5 seconds (faster for instant OFF)
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     checkMaintenance();
  //   }, 5000); // 5 seconds = INSTANT OFF
 
  //   return () => clearInterval(interval);
  // }, [checkMaintenance]);
 
  // Show loading only first time
  if (isChecking && isMaintenance === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }
 
  // Show maintenance for normal users ONLY if actually in maintenance
  if (isMaintenance &&
      location.pathname !== '/maintenance' &&
      !location.pathname.startsWith('/admin')) {
    return <MaintenancePage />;
  }
 
  // Normal pages (including when OFF)
  return children;
};
 
export default MaintenanceChecker;